import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaChevronDown } from "react-icons/fa";

const ProductFaqs = ({ faqs, heading }) => {

  const [activeIndex, setActiveIndex] =
    useState(null);

  const toggleFaq = (index) => {

    if (activeIndex === index) {
      setActiveIndex(null);
    } else {
      setActiveIndex(index);
    }

  };

  return (
    <>
      <section className="faq-section">

        <div className="container">

          {/* TOP */}
          <motion.div
            className="faq-top"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{
              duration: 0.8,
              ease: [0.22, 1, 0.36, 1],
            }}
            viewport={{ once: true }}
          >

            <motion.h3
              className="section-subheading"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{
                delay: 0.1,
                duration: 0.5,
              }}
              viewport={{ once: true }}
            >
              Your Questions Answered
            </motion.h3>

            <motion.h2
              className="section-heading"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{
                delay: 0.25,
                duration: 0.7,
              }}
              viewport={{ once: true }}
            >
            { heading || "Frequently Asked Questions" }
            </motion.h2>

          </motion.div>

          {/* GRID */}
          <motion.div
            className="faq-grid"
            variants={{
              hidden: {},
              visible: {
                transition: {
                  staggerChildren: 0.12,
                },
              },
            }}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.1 }}
          >

            {faqs.map((item, index) => {

              const isActive =
                activeIndex === index;

              return (

                <motion.div
                  className={`faq-card ${
                    isActive ? "active" : ""
                  }`}
                  key={index}
               layout="position"
                  variants={{
                    hidden: {
                      opacity: 0,
                      y: 50,
                    },
                    visible: {
                      opacity: 1,
                      y: 0,
                    },
                  }}
                  transition={{
                    duration: 0.7,
                    ease: [0.22, 1, 0.36, 1],
                  }}
                  whileHover={{
                    y: -4,
                  }}
                >

                  {/* QUESTION */}
                  <button
                    className="faq-question"
                    onClick={() =>
                      toggleFaq(index)
                    }
                  >

                    <motion.h4
                      className="card-heading"
                      transition={{
                        duration: 0.3,
                      }}
                    >
                      {item.question}
                    </motion.h4>

                    <motion.span
                      animate={{
                        rotate: isActive
                          ? 180
                          : 0,
                        scale: isActive
                          ? 1.1
                          : 1,
                      }}
                      transition={{
                        duration: 0.3,
                      }}
                    >
                      <FaChevronDown />
                    </motion.span>

                  </button>

                  {/* ANSWER */}
                  <AnimatePresence>

                    {isActive && (

                      <motion.div
                        className="faq-answer-wrapper"

                        initial={{
                          height: 0,
                          opacity: 0,
                        }}

                        animate={{
                          height: "auto",
                          opacity: 1,
                        }}

                        exit={{
                          height: 0,
                          opacity: 0,
                        }}

                        transition={{
                          duration: 0.35,
                        }}
                      >

                        <motion.p
                          className="section-text faq-answer"

                          initial={{
                            opacity: 0,
                            y: 15,
                          }}

                          animate={{
                            opacity: 1,
                            y: 0,
                          }}

                          exit={{
                            opacity: 0,
                            y: 10,
                          }}

                          transition={{
                            delay: 0.1,
                            duration: 0.3,
                          }}
                        >
                          {item.answer}
                        </motion.p>

                      </motion.div>

                    )}

                  </AnimatePresence>

                </motion.div>

              );

            })}

          </motion.div>

        </div>

      </section>
    </>
  );
};

export default ProductFaqs;